module.exports = __webpack_public_path__ + "static/img/anquan.616f09fd.png";